import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils';

export const getPaymentSummary = (query) => {
  const { Invoice, SalesEntity } = query;
  const respType = 'Inline';

  return fetchGet(`SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${Invoice}/PaymentSummary`, null, respType)
    .then((result) => result ? objectify(result.PaymentSummary) : null);
};

export const getPaymentDetails = (query) => {
  const { Invoice, SalesEntity, PaymentCode } = query;
  const respType = 'Inline';

  return fetchGet(`SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${Invoice}/PaymentDetails/${PaymentCode}`, null, respType)
    .then((result) => result ? objectify(result.PaymentDetails) : null);
};

export const fetch = async (query: { SalesEntity: string; Invoice: string; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { SalesEntity, Invoice, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${Invoice}/Payment`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        Payments: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.Payments) {

            return {
              records: result.Payments.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
